import style from "./weathertendencies.module.css"
import { TabComponent, SummaryTable, Title } from "../index";
import useTranslatedHeaders from "../../utils/constants/useTranslatedHeaders";
import { Humidity, Precipitation, Temperature, Wind } from "./charts";
import { humidity, precipitation, temperature, wind } from "../../assets/images/indicators"
import { useLanguage } from "../../components/contexts/LanguageContext"; 
import translations from "../../components/translations"; 



function WeatherTendecies() {
    const { selectedLanguage } = useLanguage(); 
    const { table1, table2 } = useTranslatedHeaders();
    return (
        <section className={style.container}>
            <Title label={`${translations[selectedLanguage].weatherTrends}`} />

            <div className={style.content}>
                <TabComponent
                    tabs={[
                        {
                            label: `${translations[selectedLanguage].temperature}`,
                            icon: <img className={style.icons} src={temperature} />,
                            component: <Temperature />,
                        },
                        {
                            label: `${translations[selectedLanguage].precipitation}`,
                            icon: <img className={style.icons} src={precipitation} />,
                            component: <Precipitation />,
                        },
                        {
                            label: `${translations[selectedLanguage].humidity}`,
                            icon: <img className={style.icons} src={humidity} />,
                            component: <Humidity />,
                        },
                        {
                            label: `${translations[selectedLanguage].wind}`,
                            icon: <img className={style.icons} src={wind} />,
                            component: <Wind />,
                        },
                    ]}
                />

                <div className={style.tableContainer}>
                    <SummaryTable rows={table1.rows} headers={table1.headers} />
                    <SummaryTable rows={table2.rows} headers={table2.headers} />
                </div>
            </div>
        </section >
    )
}

export { WeatherTendecies }